import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'russianDate'
})
export class RussianDatePipe implements PipeTransform {
  transform(value?: string | null): string {
    return value ? new Date(value).toLocaleDateString() : '';
  }
}
